<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectTrigger, type SelectTriggerProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectTriggerProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectTriggerProps>;
</script>

<template>
  <SelectTrigger v-bind="forwarded">
    <slot />
  </SelectTrigger>
</template>
